const base = 'neovehicle';

export const GetterTypes = {
  GET_CURRENT_TAB: `${base}/GET_CURRENT_TAB`,
  GET_MODEL_CLASSIFICATION_SELECTED: `${base}/GET_MODEL_CLASSIFICATION_SELECTED`,
  GET_MODEL_EDIT_SELECTED: `${base}/GET_MODEL_EDIT_SELECTED`,
  GET_MODELS: `${base}/GET_MODELS`,
  GET_BRANDS: `${base}/GET_BRANDS`,
  GET_FAMILY_VERSIONS: `${base}/GET_FAMILIES`,

  GET_FAMILY_SEGMENT_SELECTED: `${base}/GET_FAMILY_SEGMENT_SELECTED`,
  GET_FAMILIES_SEGMENT: `${base}/GET_FAMILIES_SEGMENT`,

  GET_SEGMENT_BY_MODEL: `${base}/GET_SEGMENT_BY_MODEL`,

  GET_BRAND_WITH_CONTRACTS: `${base}/GET_BRAND_WITH_CONTRACTS`,
  GET_SEGMENTS_BY_BRAND: `${base}/GET_SEGMENTS_BY_BRAND`,
  GET_FAMILIES_BY_SEGMENT: `${base}/GET_FAMILIES_BY_SEGMENT`,

  GET_FAMILY_SEGMENTS: `${base}/GET_FAMILY_SEGMENT_BY_BRAND`,

  GET_TAGS_BY_FAMILY_CONTEXT: `${base}/GET_TAGS_BY_FAMILY_CONTEXT`,
  GET_VEHICLE_TYPE_ORIGINS_RANGE: `${base}/GET_VEHICLE_TYPE_ORIGINS_RANGE`,

  GET_FAMILIES_WITH_SEGMENTS: `${base}/GET_FAMILIES_WITH_SEGMENTS`,

  GET_FAMILY_VERSIONS_MANAGEMENT: `${base}/GET_FAMILY_VERSIONS_MANAGEMENT`,
  GET_FAMILIES_MANAGEMENT: `${base}/GET_FAMILIES_MANAGEMENT`,
  GET_FAMILY_GROUPS_MANAGEMENT: `${base}/GET_FAMILY_GROUPS_MANAGEMENT`,

  GET_LAST_CLASSIFICATIONS: `${base}/GET_LAST_CLASSIFICATIONS`,

  GET_DNC_FAMILY_SELECTED: `${base}/GET_DNC_FAMILY_SELECTED`,
  GET_DNC_FAMILIES: `${base}/GET_DNC_FAMILIES`,
  GET_DNC_FAMILY_GROUPS: `${base}/GET_DNC_FAMILY_GROUPS`,
  GET_DNC_CLIENT_CONTRACTS: `${base}/GET_DNC_CLIENT_CONTRACTS`,

  GET_DNC_FAMILY_GROUP_FAILS: `${base}/GET_DNC_FAMILY_GROUP_FAILS`,

  GET_SOCIAL_CLASSES: `${base}/GET_SOCIAL_CLASSES`,
};

export const ActionTypes = {
  UPDATE_CURRENT_TAB: `${base}/UPDATE_CURRENT_TAB`,
  UPDATE_MODEL_CLASSIFICATION_SELECTED: `${base}/UPDATE_MODEL_CLASSIFICATION_SELECTED`,
  UPDATE_MODEL_EDIT_SELECTED: `${base}/UPDATE_MODEL_EDIT_SELECTED`,
  FETCH_MODELS: `${base}/FETCH_MODELS`,
  FETCH_MODELS_EXPORT: `${base}/FETCH_MODELS_EXPORT`,
  FETCH_BRANDS: `${base}/FETCH_BRANDS`,
  FETCH_FAMILY_VERSIONS: `${base}/FETCH_FAMILY_VERSIONS`,
  UPDATE_FAMILY_VERSIONS: `${base}/UPDATE_FAMILIES`,
  SAVE_MODEL_CLASSIFICATION: `${base}/SAVE_MODEL_CLASSIFICATION`,
  SAVE_MODEL: `${base}/SAVE_MODEL`,
  CLEAR_STORE: `${base}/CLEAR_STORE`,

  UPDATE_FAMILY_SEGMENT_SELECTED: `${base}/UPDATE_FAMILY_SEGMENT_SELECTED`,
  FETCH_FAMILIES_EXPORT: `${base}/FETCH_FAMILIES_EXPORT`,
  FETCH_FAMILIES_SEGMENT: `${base}/FETCH_FAMILIES_SEGMENT`,

  FETCH_SEGMENT_BY_MODEL: `${base}/FETCH_SEGMENT_BY_MODEL`,
  FETCH_BRAND_WITH_CONTRACTS: `${base}/FETCH_BRAND_WITH_CONTRACTS`,
  FETCH_SEGMENTS_BY_BRAND: `${base}/FETCH_SEGMENTS_BY_BRAND`,
  FETCH_FAMILIES_BY_SEGMENT: `${base}/FETCH_FAMILIES_BY_SEGMENT`,
  SAVE_FAMILY_CLASSIFICATION: `${base}/SAVE_FAMILY_CLASSIFICATION`,

  FETCH_FAMILY_SEGMENTS: `${base}/FETCH_FAMILY_SEGMENT_BY_BRAND`,

  FETCH_TAGS_BY_FAMILY_CONTEXT: `${base}/FETCH_TAGS_BY_FAMILY_CONTEXT`,
  FETCH_VEHICLE_TYPE_ORIGINS_RANGE: `${base}/FETCH_VEHICLE_TYPE_ORIGINS_RANGE`,

  SAVE_FAMILY_SEGMENT_FROM_OPTION: `${base}/SAVE_FAMILY_SEGMENT_FROM_OPTION`,
  CLONE_FAMILY_SEGMENT: `${base}/CLONE_FAMILY_SEGMENT`,
  FETCH_FAMILIES_WITH_SEGMENT: `${base}/FETCH_FAMILIES_WITH_SEGMENT`,

  FETCH_TAGS_BY_FAMILY_VERSION: `${base}/FETCH_TAGS_BY_FAMILY_VERSION`,

  FETCH_FAMILY_VERSIONS_MANAGEMENT: `${base}/FETCH_FAMILY_VERSIONS_MANAGEMENT`,
  FETCH_FAMILIES_MANAGEMENT: `${base}/FETCH_FAMILIES_MANAGEMENT`,
  FETCH_FAMILY_GROUPS_MANAGEMENT: `${base}/FETCH_FAMILY_GROUPS_MANAGEMENT`,
  DELETE_FAMILY_VERSIONS_MANAGEMENT: `${base}/DELETE_FAMILY_VERSIONS_MANAGEMENT`,
  DELETE_FAMILIES_MANAGEMENT: `${base}/DELETE_FAMILIES_MANAGEMENT`,
  DELETE_FAMILIES_GROUP_MANAGEMENT: `${base}/DELETE_FAMILIES_GROUP_MANAGEMENT`,
  UPDATE_FAMILY_VERSION_MANAGEMENT: `${base}/UPDATE_FAMILY_VERSION_MANAGEMENT`,
  UPDATE_FAMILY_MANAGEMENT: `${base}/UPDATE_FAMILY_MANAGEMENT`,
  UPDATE_FAMILY_GROUP_MANAGEMENT: `${base}/UPDATE_FAMILY_GROUP_MANAGEMENT`,
  UPDATE_FAMILY_VERSION_MODELS: `${base}/UPDATE_FAMILY_VERSION_MODELS`,

  FETCH_LAST_CLASSIFICATIONS: `${base}/FETCH_LAST_CLASSIFICATIONS`,

  UPDATE_FAMILY_FROM_VERSIONS: `${base}/UPDATE_FAMILY_FROM_VERSIONS`,
  UPDATE_FAMILY_GROUP_FROM_FAMILIES: `${base}/UPDATE_FAMILY_GROUP_FROM_FAMILIES`,

  INSERT_FAMILY_GROUP: `${base}/INSERT_FAMILY_GROUP`,
  INSERT_FAMILY: `${base}/INSERT_FAMILY`,

  UPDATE_DNC_FAMILY_SELECTED: `${base}/UPDATE_DNC_FAMILY_SELECTED`,
  FETCH_DNC_FAMILIES: `${base}/FETCH_DNC_FAMILY`,
  FETCH_DNC_FAMILY_GROUPS: `${base}/FETCH_DNC_FAMILY_GROUPS`,

  SAVE_DNC_FAMILY_GROUP_FAMILY: `${base}/SAVE_DNC_FAMILY_GROUP_FAMILY`,
  SAVE_DNC_FAMILY_GROUP: `${base}/SAVE_DNC_FAMILY_GROUP`,
  FETCH_DNC_CLIENT_CONTRACTS: `${base}/FETCH_DNC_CLIENT_CONTRACTS`,
  FETCH_DNC_FAMILY_GROUP_FAILS: `${base}/FETCH_DNC_FAMILY_GROUP_FAILS`,
  FETCH_DNC_FAMILY_GROUPS_EXPORT: `${base}/FETCH_DNC_FAMILY_GROUPS_EXPORT`,

  FETCH_SOCIAL_CLASSES: `${base}/FETCH_SOCIAL_CLASSES`,
};

export const MutationTypes = {
  SET_CURRENT_TAB: `${base}/SET_CURRENT_TAB`,
  SET_MODEL_CLASSIFICATION_SELECTED: `${base}/SET_MODEL_CLASSIFICATION_SELECTED`,
  SET_MODEL_EDIT_SELECTED: `${base}/SET_MODEL_EDIT_SELECTED`,
  SET_MODELS: `${base}/SET_MODELS`,
  SET_BRANDS: `${base}/SET_BRANDS`,
  SET_FAMILY_VERSIONS: `${base}/SET_FAMILIES`,
  CLEAR_STORE: `${base}/CLEAR_STORE`,

  SET_FAMILY_SEGMENT_SELECTED: `${base}/SET_FAMILY_SEGMENT_SELECTED`,
  SET_FAMILIES_SEGMENT: `${base}/SET_FAMILIES_SEGMENT`,

  SET_SEGMENT_BY_MODEL: `${base}/SET_SEGMENT_BY_MODEL`,
  SET_BRAND_WITH_CONTRACTS: `${base}/SET_BRAND_WITH_CONTRACTS`,
  SET_SEGMENTS_BY_BRAND: `${base}/SET_SEGMENTS_BY_BRAND`,
  SET_FAMILIES_BY_SEGMENT: `${base}/SET_FAMILIES_BY_SEGMENT`,

  SET_FAMILY_SEGMENTS: `${base}/SET_FAMILY_SEGMENT_BRAND`,

  SET_TAGS_BY_FAMILY_CONTEXT: `${base}/SET_TAGS_BY_FAMILY_CONTEXT`,
  SET_VEHICLE_TYPE_ORIGINS_RANGE: `${base}/SET_VEHICLE_TYPE_ORIGINS_RANGE`,
  SET_FAMILIES_WITH_SEGMENT: `${base}/SET_FAMILIES_WITH_SEGMENT`,

  SET_FAMILY_VERSIONS_MANAGEMENT: `${base}/SET_FAMILY_VERSIONS_MANAGEMENT`,
  SET_FAMILIES_MANAGEMENT: `${base}/SET_FAMILIES_MANAGEMENT`,
  SET_FAMILY_GROUPS_MANAGEMENT: `${base}/SET_FAMILY_GROUPS_MANAGEMENT`,

  SET_LAST_CLASSIFICATIONS: `${base}/SET_LAST_CLASSIFICATIONS`,

  SET_DNC_FAMILY_GROUP_SELECTED: `${base}/SET_DNC_FAMILY_GROUP_SELECTED`,
  SET_DNC_FAMILIES: `${base}/SET_DNC_FAMILY`,
  SET_DNC_FAMILY_GROUPS: `${base}/SET_DNC_FAMILY_GROUPS`,

  SET_DNC_CLIENT_CONTRACTS: `${base}/SET_DNC_CLIENT_CONTRACTS`,
  SET_DNC_FAMILY_GROUP_FAILS: `${base}/SET_DNC_FAMILY_GROUP_FAILS`,

  SET_SOCIAL_CLASSES: `${base}/SET_SOCIAL_CLASSES`,
};
